import WithDirection from '@app/settings/withDirection';
import { Transfer } from 'antd';
import AntTransfer from './styles/transfer.style';

const WDTransfers = AntTransfer(Transfer);

export const IsoTransfer = WithDirection(WDTransfers);
